<template>
  <div class="cart-items">
    <CartItemRow
      v-for="item in items"
      :key="item.cart_item_key || `${item.product_id}-${item.pro_sale_code_id || ''}`"
      :item="item"
      :currency="currency"
      @increase="$emit('increase', $event)"
      @decrease="$emit('decrease', $event)"
      @quantity-change="$emit('quantity-change', $event)"
      @remove="$emit('remove', $event)"
      @edit="$emit('edit', $event)"
    />

    <div v-if="!items.length" class="empty-cart">
      <div class="empty-cart-icon">
        <i class="fas fa-shopping-basket"></i>
      </div>
      <strong>{{ $t('retailSale.cart.emptyTitle') }}</strong>
      <p>{{ $t('retailSale.cart.emptyHint') }}</p>
      <div class="empty-cart-actions">
        <span>
          <i class="fas fa-barcode"></i>
          {{ $t('retailSale.cart.emptyScanHint') }}
        </span>
        <span>
          <i class="fas fa-plus"></i>
          {{ $t('retailSale.cart.emptyAddHint') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CartItemRow from './CartItemRow.vue'

export default {
  name: 'CartItemList',
  components: {
    CartItemRow
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currency: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped src="../../styles/cart-item-list.css"></style>
